import type { Vacancy } from 'clients/AutoCompleteClient/types';
import type { IndeedProject } from 'shared/legacy/hooks/useBrowserExtension/indeed/useIndeedProjectListQuery';

type IndeedActivationStateParams = {
  isLoading: boolean;
  isProcessingVacancy: boolean;
  selectedIndeedProject: IndeedProject | null;
  selectedVacancy: Vacancy | null;
};

export const getHasNoIndeedCredits = (indeedConfig: { creditBalance: number; isInitialLoading: boolean }) => {
  return !indeedConfig.isInitialLoading && indeedConfig.creditBalance <= 0;
};

const isHighQualityVacancy = (selectedVacancy: Vacancy | null) => {
  return (selectedVacancy?.quality_percent ?? 0) > 66;
};

export const getIndeedActivationState = ({
  isLoading,
  isProcessingVacancy,
  selectedIndeedProject,
  selectedVacancy,
}: IndeedActivationStateParams) => {
  const isQualityHigh = isHighQualityVacancy(selectedVacancy);
  const shouldShowQualityError = !!selectedVacancy && !isProcessingVacancy && !isQualityHigh;

  return {
    isConfirmDisabled: !selectedVacancy || !selectedIndeedProject || !isQualityHigh || isProcessingVacancy || isLoading,
    shouldShowQualityError,
  };
};
